import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import {
  setEditMode,
} from '../../actions/advisor';
import {
  BS_TEST,
  LA_TEST,
  RR_TEST,
  LF_TEST,
} from '../../constants.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faRocket, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import EditClientForm from './EditClientForm';
import EditGoalsForm from './EditGoalsForm';
import EditHoldingsForm from './EditHoldingsForm';
import SelectModelForm from './SelectModelForm';
import s from './EditClient.css';
import './tooltip.css';

library.add(faEdit, faRocket, faInfoCircle);

class EditClient extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedFamily: this.getModelFamilies()[0],
      selectedLossFrequency: 0,
    };
  }

  setEditMode(mode) {
    this.props.setEditMode(mode);
  }

  setSelectedFamily = (event) => {
    const target = event.target;
    const {
      value,
     } = target;
    this.setState(Object.assign({}, this.state, {
      selectedFamily: value,
    }));
  }

  setSelectedLossFrequency(value) {
    this.setState(Object.assign({}, this.state, {
      selectedLossFrequency: value,
    }));
  }

  openClientTest(clientID) {
    window.open('/?clientID=' + clientID);
  }

  formatNum(val) {
    if(val) {
      return '$' + val.toLocaleString();
    } else {
      return '$0';
    }
  }

  getLastTestResult(test, results) {
    if (results) {
      const sortedResults = results.filter((result) => result.name === test);
      if (sortedResults.length > 0) {
        return sortedResults[sortedResults.length - 1];
      }
      return null;
    } else {
      return null;
    }
  }

  getBrief(result) {
    if(result) {
      return result.brief;
    } else {
      return '';
    }
  }

  getDescription(result) {
    if(result) {
      return result.result;
    } else {
      return '';
    }
  }

  getModelFamilies() {
    const {
      client,
    } = this.props;
    
    return [...new Set(client.fullTermModels.sort((a, b) => b.score - a.score).map((model) => model.modelFamily))];
  }

  getModelFamiliesOptions() {
    const families = this.getModelFamilies();
    return (
      families.map((name) => {
        return (<option>{name}</option>);
      })
    )
  }

  renderModels(models,term) {
    return (
      models.sort((a, b) => b.score - a.score).map((model) => {
        const style = {background:'#FFFFFF'};
        if (model.name === 'Client Portfolio') {
          style.background = 'aliceblue';
        }
        if (model.scoreWgt === 1.0) {
          style.background = 'aliceblue';
        } 
        return (
          <tr key={model.name + term} style={style}>
            <td style={{fontSize:'18px',padding:'15px',fontWeight:'900'}}>{Math.round(model.scoreWgt * 100)}</td>
            <td style={{padding:'15px'}}>{Math.round(model.metGoalPct * 100)}%</td>
            <td style={{padding:'15px',fontWeight:'900'}}>{model.name}</td>
            <td style={{padding:'15px'}}>{model.modelFamily}</td>
            <td style={{padding:'15px'}}>{model.modelRiskTolerance}</td>
            <td style={{padding:'15px'}}>{model.modelRiskToleranceRank}</td>
            <td style={{padding:'15px'}}>{(model.expectedReturns * 100).toFixed(2)}%</td>
            <td style={{padding:'15px'}}>{(model.expectedVolatility * 100).toFixed(2)}%</td>
          </tr>
        );
      })
    );
  }

  renderSelectedModel(selection) {
    const {
      client,
    } = this.props;

    const {
      selectedFamily,
      selectedLossFrequency,
    } = this.state;

    const models = client.fullTermModels.sort((a, b) => b.score - a.score);
    let model = models[0];
    if(selection === 'client') {
      model = models.filter((x) => {
        return x.name === 'Client Portfolio';
      })[0];
    } else {
      const family = models.filter((x) => x.modelFamily === selectedFamily);
      model = family[0];
      if(selectedLossFrequency > 0) {
        const rank = model.modelRiskToleranceRank;
        let ranked = family.filter((x) => x.modelRiskToleranceRank === (rank - selectedLossFrequency))[0];
        if(!ranked) {
          ranked = family.filter((x) => x.modelRiskToleranceRank === (rank - selectedLossFrequency + 1))[0];
        }
        if(ranked) {
          model = ranked;
        }
      }
    }

    return (
      <div className={s.modelContent} style={{textAlign:'center'}}>
        <div style={{margin:'24px',height:'140px', }}>
          <div style={{fontSize:'24px', fontWeight:'900'}}>{model.name}</div>
          <div style={{color:'#8C959B', lineHeight:'18px', fontSize:'18px', fontWeight:'400'}}>{model.modelRiskTolerance}</div>
        </div>
        <div style={{margin:'36px'}}>
          <div style={{color:'#5b6770', lineHeight:'72px', fontSize:'72px', fontWeight:'600'}}>{Math.round(model.scoreWgt * 100)}</div>
          <div style={{color:'#8C959B', lineHeight:'18px', fontSize:'18px', fontWeight:'400'}}>Personalization Score</div>
        </div>
        <div style={{margin:'36px'}}>
          <div style={{color:'#5b6770', lineHeight:'48px', fontSize:'48px', fontWeight:'400'}}>{Math.round(model.metGoalPct * 100)}<sup style={{fontSize: '24px'}}>%</sup></div>
          <div style={{color:'#8C959B', lineHeight:'18px', fontSize:'18px', fontWeight:'400'}}>Chance to Meet Your Goal</div>
        </div>
        <div style={{margin:'36px'}}>
          <div style={{color:'#5b6770', lineHeight:'48px', fontSize:'48px', fontWeight:'400'}}>{(model.expectedReturns * 100).toFixed(2)}<sup style={{fontSize: '24px'}}>%</sup></div>
          <div style={{color:'#8C959B', lineHeight:'18px', fontSize:'18px', fontWeight:'400'}}>Expected Returns</div>
        </div>
        <div style={{margin:'36px'}}>
          <div style={{color:'#5b6770', lineHeight:'48px', fontSize:'48px', fontWeight:'400'}}>{(model.expectedVolatility * 100).toFixed(2)}<sup style={{fontSize: '24px'}}>%</sup></div>
          <div style={{color:'#8C959B', lineHeight:'18px', fontSize:'18px', fontWeight:'400'}}>Expected Volatility</div>
        </div>
      </div>
    );
  }

  getButtonStyle(val) {
    const {
      selectedLossFrequency,
    } = this.state;

    const style = {color:'#05A9B1', border:'1px solid #05A9B1', display:'inline-block', height:'44px', width:'33.33%', textAlign:'center',fontSize:'18px', lineHeight:'44px', cursor:'pointer'};
    if(val === selectedLossFrequency) {
      style.color = '#FFFFFF';
      style.background = '#05A9B1';
    }
    return style;
  }

  render() {
    const {
      client,
      editMode,
    } = this.props;

    const {
      selectedFamily,
    } = this.state;

    const LA = this.getLastTestResult(LA_TEST, client.results);
    const RR = this.getLastTestResult(RR_TEST, client.results);
    const BS = this.getLastTestResult(BS_TEST, client.results);
    const LF = this.getLastTestResult(LF_TEST, client.results);

    let num_tickers = 0;
    if(client.holdings.length > 0) {
      let cleanHoldings = [{
        tickers: client.holdings[client.holdings.length - 1].tickers,
        weights: client.holdings[client.holdings.length - 1].weights,
      }];
      client.holdings = cleanHoldings;
      num_tickers = client.holdings[client.holdings.length - 1].tickers.length
    }

    return (
      <div>
      <div className="row">
        <div className="col-md-7">
          <div className={s.content}>
            <div className="row">
              <div className="col-md-10">
                <div className={s.clientName}>{client.firstName} {client.lastName}</div>
                <div className={s.clientEmail}>{client.email}</div>
              </div>
              <div className='col-md-2'>
                <div className={s.editButton} onClick={() => this.setEditMode('general')}>
                  <FontAwesomeIcon icon="edit" size="1x"/>
                </div>
              </div>
            </div>
            <div className={s.line}/>
            <div className="row">
              <div className="col-md-10">
                <div className={s.clientSection} style={{marginTop: '0px'}}>Goals</div>
              </div>
              <div className='col-md-2'>
                <div className={s.editButton}  onClick={() => this.setEditMode('goals')}>
                  <FontAwesomeIcon icon="edit" size="1x"/>
                </div>
              </div>
              <div className="col-md-1"></div>
              <div className="col-md-11">
                <div className={s.clientGoal} style={{marginTop: '0px'}}><span className={s.goalLabel}>Birth Year:</span> {client.birthYear}</div>
                <div className={s.clientGoal}><span className={s.goalLabel}>Retirement Age:</span> {client.retireAge}</div>
                <div className={s.clientGoal}><span className={s.goalLabel}>Current Savings:</span> {this.formatNum(client.currentSavings)}</div>
                <div className={s.clientGoal}><span className={s.goalLabel}>Pre-Retirement Monthly Contribution:</span> {this.formatNum(client.monthlySavings)}</div>
                <div className={s.clientGoal}><span className={s.goalLabel}>Prefered Retirement Annual Income:</span> {this.formatNum(client.retireMonthlyIncome)}</div>
                <div className={s.clientGoal}><span className={s.goalLabel}>Mid Term Horizon (years):</span> {client.shortTermYears}</div>
                <div className={s.clientGoal}><span className={s.goalLabel}>Loss Aversion Score (override):</span> {client.laScore}</div>
              </div>
            </div>
            <div className={s.line}/>
            <div className="row">
              <div className="col-md-10">
                <div className={s.clientSection} style={{marginTop: '0px'}}>Behavioral Profile</div>
              </div>
              <div className='col-md-2'>
                <div className={s.editButton} style={{paddingLeft:'0px',paddingTop:'7px'}} onClick={() => this.openClientTest(client.id)}>
                  <FontAwesomeIcon icon="rocket" size="1x"/>
                </div>
              </div>
              <div className="col-md-1"></div>
              <div className="col-md-11">
                <div className={s.clientGoal} style={{marginTop: '0px'}}><span className={s.goalLabel}>Loss Aversion:</span> {this.getBrief(LA)} <FontAwesomeIcon data-tip data-for={'loss-averion'} style={{cursor:'pointer'}} icon="info-circle" size="sm" color="#05A9B1"/>
                  <ReactTooltip id={'loss-averion'} type='light' className="feetip" effect="float">
                    <div dangerouslySetInnerHTML={{__html:this.getDescription(LA)}} />
                  </ReactTooltip>
                </div>
                <div className={s.clientGoal}><span className={s.goalLabel}>Behavioral Stress:</span> {this.getBrief(BS)} <FontAwesomeIcon data-tip data-for={'behavioral-stress'} style={{cursor:'pointer'}} icon="info-circle" size="sm" color="#05A9B1"/>
                  <ReactTooltip id={'behavioral-stress'} type='light' className="feetip" effect="float">
                    <div dangerouslySetInnerHTML={{__html:this.getDescription(BS)}} />
                  </ReactTooltip>
                </div>
                <div className={s.clientGoal}><span className={s.goalLabel}>Present Bias:</span> {this.getBrief(RR)} <FontAwesomeIcon data-tip data-for={'retirement-regret'} style={{cursor:'pointer'}} icon="info-circle" size="sm" color="#05A9B1"/>
                  <ReactTooltip id={'retirement-regret'} type='light' className="feetip" effect="float">
                    <div dangerouslySetInnerHTML={{__html:this.getDescription(RR)}} />
                  </ReactTooltip>
                </div>
                <div className={s.clientGoal}><span className={s.goalLabel}>Loss Frequency:</span> {this.getBrief(LF)} <FontAwesomeIcon data-tip data-for={'retirement-regret'} style={{cursor:'pointer'}} icon="info-circle" size="sm" color="#05A9B1"/>
                  <ReactTooltip id={'retirement-regret'} type='light' className="feetip" effect="float">
                    <div dangerouslySetInnerHTML={{__html:this.getDescription(LF)}} />
                  </ReactTooltip>
                </div>
              </div>
            </div>
            <div className={s.line}/>
            <div className="row">
              <div className="col-md-10">
                <div className={s.clientSection} style={{marginTop: '0px'}}>Client Portfolio</div>
              </div>
              <div className='col-md-2'>
                <div className={s.editButton} onClick={() => this.setEditMode('holdings')}>
                  <FontAwesomeIcon icon="edit" size="1x"/>
                </div>
              </div>
              <div className="col-md-1"></div>
              <div className="col-md-11">
                <div className={s.clientGoal} style={{marginTop: '0px'}}><span className={s.goalLabel}>Number of holdings in portfolio:</span> {num_tickers}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-5">
          <div className={s.content}>
            {editMode === '' &&
              <SelectModelForm client={client} />
            }
            {editMode === 'general' &&
              <EditClientForm client={client}/>
            }
            {editMode === 'goals' &&
              <EditGoalsForm client={client}/>
            }
            {editMode === 'holdings' &&
              <EditHoldingsForm client={client}/>
            }
          </div>
        </div>
      </div>

      {!client.isDirty &&
      <div>
        <div className="row">
          <div className="col-md-6">
            <div className={'form-group'}>
            <label htmlFor="selectedFamily" className={s.formLabel} style={{color:'#8C959B', lineHeight:'18px', fontSize:'18px', fontWeight:'400'}}>WisdomTree Model Family</label>
            <select
              name="selectedFamily"
              value={selectedFamily}
              onChange={this.setSelectedFamily}
              className={'form-control'}
            >
              {this.getModelFamiliesOptions()}
            </select>
            </div>
          </div>
          {/* <div className="col-md-6">
            <div className={'form-group'}>
            <label htmlFor="selectedLossFrequency" className={s.formLabel} style={{color:'#8C959B', lineHeight:'18px', fontSize:'18px', fontWeight:'400'}}>Client Loss Fequency</label>
            <select
              name="selectedLossFrequency"
              value={selectedLossFrequency}
              onChange={this.setSelectedLossFrequency}
              className={'form-control'}
            >
              <option value="0">Low</option>
              <option value="1">Medium</option>
              <option value="2">High</option>
            </select>
            </div>
          </div> */}
        </div>
        <div className="row" style={{marginBottom:'15px'}}>
          <div className="col-md-12">
            <div style={this.getButtonStyle(0)} onClick={() => this.setSelectedLossFrequency(0)}>LOW LOSS FREQUENCY</div>
            <div style={this.getButtonStyle(1)} onClick={() => this.setSelectedLossFrequency(1)}>MEDIUM LOSS FREQUENCY</div>
            <div style={this.getButtonStyle(2)} onClick={() => this.setSelectedLossFrequency(2)}>HIGH LOSS FREQUENCY</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            {this.renderSelectedModel('wisdomtree')}
          </div>
          <div className="col-md-6">
            {this.renderSelectedModel('client')}
          </div>
        </div>
      </div>
      }

      {!client.isDirty &&
        <div className="row">
          <div className="col-md-12">
            <div className={s.modelContent}>
              <div className={s.modelTitle}>FULL TERM {client.retireAge - (2020 - client.birthYear)} YRS (testing only)</div>
              <table class="table" style={{width:'100%', fontSize:'14px', color:'#5b6770'}}>
                <tr>
                  <th style={{verticalAlign:'bottom', padding:'15px', color:'white', background:'#0047BB'}}>SCORE</th>
                  <th style={{verticalAlign:'bottom', padding:'15px', color:'white', background:'#0047BB'}}>MEET GOAL CHANCE</th>
                  <th style={{verticalAlign:'bottom', padding:'15px', color:'white', background:'#0047BB'}}>MODEL NAME</th>
                  <th style={{verticalAlign:'bottom', padding:'15px', color:'white', background:'#0047BB'}}>MODEL FAMILY</th>
                  <th style={{verticalAlign:'bottom', padding:'15px', color:'white', background:'#0047BB'}}>MODEL RISK NAME</th>
                  <th style={{verticalAlign:'bottom', padding:'15px', color:'white', background:'#0047BB'}}>MODEL RISK RANK</th>
                  <th style={{verticalAlign:'bottom', padding:'15px', color:'white', background:'#0047BB'}}>EXPECTED RETURNS</th>
                  <th style={{verticalAlign:'bottom', padding:'15px', color:'white', background:'#0047BB'}}>EXPECTED VOLATILITY</th>
                </tr>
                {this.renderModels(client.fullTermModels, 'full')}
              </table>
            </div>
          </div>
        </div>
      }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    editMode: state.advisorData.editMode,
  };
}

export default connect(mapStateToProps, {
  setEditMode,
})(EditClient);




// WEBPACK FOOTER //
// ./src/components/AdvisorMode/EditClient.js